import React from 'react';
import styled from 'styled-components';
import Logo from './Logo';
import { ThinkfabLogo, WeDoDevLogo } from './Logo';
import Header from './Header';
import Footer from './Footer';
import { ContactButton } from './Contact';

const ExampleContainer = styled.div`
  font-family: var(--font-primary);
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;
`;

const Section = styled.section`
  margin-bottom: 60px;
`;

const Title = styled.h1`
  font-size: 28px;
  margin-bottom: 20px;
  font-weight: var(--font-weight-semibold);
`;

const SectionTitle = styled.h2`
  font-size: 20px;
  margin-bottom: 15px;
  font-weight: var(--font-weight-medium);
`;

const Example = styled.div`
  margin-bottom: 40px;
`;

const ExampleTitle = styled.h3`
  font-size: 16px;
  margin-bottom: 10px;
  font-weight: var(--font-weight-medium);
`;

const ExampleDescription = styled.p`
  font-size: 14px;
  margin-bottom: 20px;
`;

const HeaderWrapper = styled.div`
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 30px;
`;

const LogoSection = styled.div`
  margin-bottom: 20px;
`;

const ExampleUsage: React.FC = () => {
  return (
    <ExampleContainer>
      <Title>Exemples d'utilisation des composants</Title>
      
      <Section>
        <SectionTitle>Exemples d'utilisation du Header</SectionTitle>
        
        <Example>
          <ExampleTitle>Header avec fond bleu (par défaut)</ExampleTitle>
          <ExampleDescription>
            Utilisez <code>{`<Header />`}</code> ou <code>{`<Header backgroundColor={undefined} />`}</code>
          </ExampleDescription>
          <HeaderWrapper>
            <Header />
          </HeaderWrapper>
        </Example>
        
        <Example>
          <ExampleTitle>Header avec fond rouge</ExampleTitle>
          <ExampleDescription>
            Utilisez <code>{`<Header backgroundColor="#DD3114" />`}</code>
          </ExampleDescription>
          <HeaderWrapper>
            <Header backgroundColor="#DD3114" />
          </HeaderWrapper>
        </Example>
        
        <Example>
          <ExampleTitle>Header avec fond blanc</ExampleTitle>
          <ExampleDescription>
            Utilisez <code>{`<Header backgroundColor="white" />`}</code>
          </ExampleDescription>
          <HeaderWrapper>
            <Header backgroundColor="white" />
          </HeaderWrapper>
        </Example>
        
        <Example>
          <ExampleTitle>Header avec fond vert</ExampleTitle>
          <ExampleDescription>
            Utilisez <code>{`<Header backgroundColor="#7CC476" />`}</code>
          </ExampleDescription>
          <HeaderWrapper>
            <Header backgroundColor="#7CC476" />
          </HeaderWrapper>
        </Example>
      </Section>
      
      <Section>
        <SectionTitle>Exemples d'utilisation du Logo</SectionTitle>
        
        <LogoSection>
          <ExampleTitle>Logo complet</ExampleTitle>
          <Logo 
            thinkfabColor="#011D3A" 
            separatorColor="#011D3A" 
            weDoColor="#011D3A" 
            devColor="#DD3114" 
            size="32px" 
          />
        </LogoSection>
        
        <LogoSection>
          <ExampleTitle>Logo Thinkfab séparé</ExampleTitle>
          <ThinkfabLogo 
            thinkfabColor="#011D3A" 
            separatorColor="#011D3A" 
            size="32px" 
          />
        </LogoSection>
        
        <LogoSection>
          <ExampleTitle>Logo We Do Dev séparé</ExampleTitle>
          <WeDoDevLogo 
            weDoColor="#011D3A" 
            devColor="#DD3114" 
            size="32px" 
          />
        </LogoSection>
        
        <LogoSection>
          <ExampleTitle>Utilisation sans séparateur</ExampleTitle>
          <ThinkfabLogo 
            thinkfabColor="#011D3A" 
            hideSeparator={true}
            size="32px" 
          />
        </LogoSection>
      </Section>
      
      <Section>
        <SectionTitle>Bouton de Contact Modal</SectionTitle>
        
        <Example>
          <ExampleTitle>Exemples de variantes du bouton de contact</ExampleTitle>
          <ExampleDescription>
            Le bouton ContactButton ouvre une modale de formulaire de contact qui envoie un message à Slack.
          </ExampleDescription>
          
          <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
            <ContactButton>Variante par défaut (primary)</ContactButton>
            <ContactButton variant="secondary">Variante secondary</ContactButton>
            <ContactButton variant="outline">Variante outline</ContactButton>
          </div>
          
          <ExampleTitle>Comment utiliser</ExampleTitle>
          <ExampleDescription>
            Importez le composant et utilisez-le n'importe où dans votre application:<br/>
            <code>{`import { ContactButton } from '../components';`}</code><br/>
            <code>{`<ContactButton>Contactez notre équipe</ContactButton>`}</code><br/>
            <code>{`<ContactButton variant="secondary">Discuter d'un projet</ContactButton>`}</code><br/>
            <code>{`<ContactButton variant="outline">Demande d'information</ContactButton>`}</code>
          </ExampleDescription>
        </Example>
        
        <Example>
          <ExampleTitle>Intégration dans le Footer</ExampleTitle>
          <ExampleDescription>
            Vous pouvez remplacer le bouton standard du footer par un bouton de contact modal:
          </ExampleDescription>
          
          <div style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '20px', background: '#f5f5f5' }}>
            <Footer 
              heading="Exemple de Footer"
              subheading="Avec bouton de contact intégré"
              customButton={<ContactButton variant="secondary">Me contacter</ContactButton>}
            />
          </div>
        </Example>
      </Section>
    </ExampleContainer>
  );
};

export default ExampleUsage;